export default {
  projectManagementApi: {
    getDataSourceOptions: '/api/projectManagement/getDataSourceOptions',
    getProjects: 'api/projectManagement/getProjects',
    addProject: 'api/projectManagement/addProject',
    updateProject: 'api/projectManagement/updateProject',

    projectPageList: 'api/projectManagement/projectPageList',
    delProject: 'api/projectManagement/delProject',
    getProjectDataSources: 'api/projectManagement/getProjectDataSources',
    delDatasource: 'api/projectManagement/delDatasource',
    addProjectDataSource: 'api/projectManagement/addProjectDataSource',
    updateProjectDataSource: 'api/projectManagement/updateProjectDataSource',
  }
}